<template>
  <div class="container_box">
    <!--tab栏区域-->
    <Tabs v-model="tabPayStatus" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in payStatusList" :label="item.title" :name="item.value.toString()"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004632')" prop="packagePayCodes">
              <Input type="textarea" :placeholder="$t('key1004633')" v-model.trim="pageParams.packagePayCodes"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004634')" prop="packageCodes">
              <Input type="textarea" :placeholder=" $t('key1004631')" v-model.trim="pageParams.packageCodes"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003736')" prop="distributorMerchantId">
              <Input clearable v-model.trim="pageParams.distributorMerchantId"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001491')" prop="channel">
              <Select v-model="pageParams.channel" filterable>
                <Option v-for="(item, index) in channelList" :value="item.channel" :key="index">{{ item.channel }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001492')" prop="account">
              <Input clearable v-model.trim="pageParams.account"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="tabPayStatus === 'null'">
            <Form-item :label="$t('key1004635')" prop="payStatus">
              <Select  v-model="pageParams.payStatus">
                <Option v-for="(item, index) in payStatusList" :value="item.value" :key="index">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box" v-if="getPermission('ymsPackagePay_confirmPayVoucher') && ['null', '2'].includes(tabPayStatus)">
      <!--批量对账-->
      <Button type="primary" class="mr15" @click="batchReconciliationBtn">{{ $t('key1004636') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="510"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange"
        :span-method="handleSpan">
        <!--支付流水图片-->
        <template #paymentReceiptImage="{row, index}">
          <div class="flex align-items-center mt5 mb5" v-viewer="viewerOptions">
            <img class="ml5 mr5 cursor" v-for="item in row.ymsPackagePayVouchers" width="60" height="60"
              :src="setImgPath(item.imagePath, null, null, null, false)" alt="">
          </div>
        </template>
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--日志弹窗-->
    <commonLogModal ref="commonLog" logMode="YMS_STANDARD" :logType="['SYSTEM_LOG', 'DISTRIBUTOR_LOG']">
      <h2 class="mb10">{{ $t('key1004634') + businessOrderNumber + $t('key1003201') }}</h2>
    </commonLogModal>
    <!--批量对账弹窗-->
    <batchReconciliationModal ref="batchReconciliation" @updateData="pageParamsStatus = true"></batchReconciliationModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import commonLogModal from "@/components/common/commonLogModal.vue";
import batchReconciliationModal from "@/views/yms/components/orderList/batchReconciliationModal.vue";
import {amountHandel, getPaymentChannelsData, isValueEmpty} from "@/utils/common";

export default {
  name: 'orderPaymentReconciliation',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      tabPayStatus: 'null',
      pageParams: {
        account: null,
        channel: null,
        distributorMerchantId: null,
        packagePayCodes: null,
        packageCodes: null,
        payStatus: 'null',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      originalColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'idx',
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004616'),
          align: 'center',
          key: 'packagePayCode',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004617'),
          align: 'center',
          key: 'totalPayableAmount',
          minWidth: 150,
          render(h, params) {
            let currency = params.row.totalOrderAmountCurrency;
            let totalOrderAmount = amountHandel(params.row.totalOrderAmount);
            let price = !isValueEmpty(totalOrderAmount) ? (totalOrderAmount + ' ' + currency) : '-';
            let receiveCurrency = params.row.currency;
            let receiveTotalPrice = amountHandel(params.row.receiveTotalPrice);
            let receivePrice = !isValueEmpty(receiveTotalPrice) ? (receiveTotalPrice + ' ' + receiveCurrency) : '-';
            return h('div', [
              h('p', price),
              h('p', `(${receivePrice})`),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004618'),
          align: 'center',
          key: 'channel',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004619'),
          align: 'center',
          key: 'account',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004620'),
          align: 'center',
          key: 'distributorMerchantId',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004621'),
          key: 'businessCode',
          align: 'center',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004622'),
          align: 'center',
          key: 'businessAmount',
          minWidth: 150,
          render(h, params) {
            let currency = params.row.orderAmountCurrency;
            let orderAmount = amountHandel(params.row.orderAmount);
            let price = !isValueEmpty(orderAmount) ? (orderAmount + ' ' + currency) : '-';
            return h('span', price);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004623'),
          align: 'center',
          key: 'paymentReceiptImage',
          minWidth: 350,
          slot: 'paymentReceiptImage'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004624'),
          align: 'center',
          key: 'payStatus',
          minWidth: 150,
          render(h, params) {
            let payStatus = params.row.payStatus;
            let text = '';
            v.payStatusList.map((item) => {
              if (item.value === payStatus) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350'),
          align: 'center',
          key: 'remark',
          width: 200,
          render: (h, params) => {
            return v.checkContentOverflow(h, params.row.remark, 200, 1);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          fixed: 'right',
          width: 200,
          render(h, params) {
            let ymsPackagePayId = params.row.ymsPackagePayId;
            let payStatus = params.row.payStatus;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004625'),
                    show: v.getPermission('ymsPackagePay_confirmPayVoucher') && payStatus === 2,
                    clickFn: () => {
                      v.$refs['batchReconciliation'].initBatchReconciliationData('single', [params.row]);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.businessOrderNumber = params.row.businessCode;
                      v.$refs['commonLog'].initCommonLogData(ymsPackagePayId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableColumns: [],
      tableData: [],
      payStatusList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004626')},
        {value: 4, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004627')},
        {value: 3, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004628')}
      ],
      selectTableData: [],
      channelList: [],
      businessOrderNumber: null
    };
  },
  created() {
    getPaymentChannelsData().then((data) => {
      this.channelList = data;
    });
    this.handleColumns();
    this.search();
  },
  methods: {
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.getList();
    },
    // 切换Tab
    changeTab(value) {
      this.pageParams.payStatus = value;
      this.search();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      let nullKeyList = ['payStatus'];
      for (let key of nullKeyList) {
        params[key] = v.pageParams[key] === 'null' ? null : Number(v.pageParams[key]);
      }
      let filterKeyList = ['packagePayCodes', 'packageCodes'];
      for (let key of filterKeyList) {
        params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
      }
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.handleColumns();
      v.optionBtnWidth = [];
      if (v.getPermission('ymsPackagePay_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsPackagePay_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let list = data.list || [];
              let newList = [];
              if (list.length > 0) {
                list.map((item) => {
                  let ymsPackagePayDetails = item.ymsPackagePayDetails || [];
                  let length = ymsPackagePayDetails.length;
                  ymsPackagePayDetails.map((ele, index) => {
                    ele.orderAmount = ele.totalPrice;
                    ele.orderAmountCurrency = ele.totalPriceCurrency;
                    ele.totalOrderAmount = item.totalPrice;
                    ele.totalOrderAmountCurrency = item.totalPriceCurrency;
                    ele['length'] = length;
                    ele['currentTalg'] = (length > 1 && index === 0);
                    let obj = Object.assign({}, item, ele);
                    newList.push(obj);
                  });
                });
              }
              if (newList.length > 0) {
                newList.map((item, index) => {
                  item['tableLength'] = newList.length;
                  if (item.currentTalg) {
                    item['currentIndex'] = index;
                  }
                });
                v.tableData = newList;
                v.$forceUpdate();
              }
              v.total = data.total;
              v.updateTableDom('selection');
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = data;
    },
    // 批量对账
    batchReconciliationBtn() {
      if (this.selectTableData.length <= 0) {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004629'));
        return false;
      } else {
        let newList = this.selectTableData.filter((item) => item.payStatus === 2);
        if (newList.length > 0) {
          this.$refs['batchReconciliation'].initBatchReconciliationData('all', newList);
        } else {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004630'));
        }
      }
    },
    // 处理列表字段
    handleColumns() {
      let v = this;
      v.tableColumns = [];
      let hideKeyList = [];
      if (['null'].includes(v.tabPayStatus)) {
        v.tableColumns = v.originalColumns;
      } else {
        hideKeyList = ['payStatus'];
        v.tableColumns = v.originalColumns.filter((item) => {
          return !hideKeyList.includes(item.key);
        });
      }
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let v = this;
      let columnList = [];
      let handleKeyList = ['businessCode', 'businessAmount'];
      if (v.tableColumns.length > 0) {
        v.tableColumns.map((item, index) => {
          if (!handleKeyList.includes(item.key)) {
            columnList.push(index);
          }
        });
      }
      if (columnList.includes(columnIndex)) {
        if (row.length > 1) {
          if (rowIndex === row.currentIndex) {
            return [row.length, 1];
          } else {
            for (let i = 0; i <= row.tableLength; i++) {
              if (rowIndex === i) {
                return [0, 0];
              }
            }
          }
        }
      }
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    commonLogModal,
    batchReconciliationModal
  }
};
</script>

<style lang="less">

</style>
